/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tl_Set_Dates_HintInputs */

const en_tl_set_dates_hint = /** @type {(inputs: Tl_Set_Dates_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick the start, then the due date. The same day twice makes a one-day item.`)
};

const de_tl_set_dates_hint = /** @type {(inputs: Tl_Set_Dates_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wähle den Start, dann die Fälligkeit. Zweimal derselbe Tag ergibt einen eintägigen Vorgang.`)
};

/**
* | output |
* | --- |
* | "Pick the start, then the due date. The same day twice makes a one-day item." |
*
* @param {Tl_Set_Dates_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tl_set_dates_hint = /** @type {((inputs?: Tl_Set_Dates_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tl_Set_Dates_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_tl_set_dates_hint(inputs)
	return en_tl_set_dates_hint(inputs)
});